import React, { useState } from 'react';
import { ChevronDown, ChevronsLeft, ChevronsRight, LogOut } from 'lucide-react';
import { visibleModules, findItem } from './modules';
import { useAuth } from '../context/AuthContext';

export const AdminSidebar = ({ active, onSelect, collapsed, onToggle, badges = {}, user, onLogout }) => {
  const { can } = useAuth();
  const [open, setOpen] = useState(() => ({ [findItem(active)?.module.key || 'home']: true }));

  const toggleModule = (key) => {
    if (collapsed) onToggle();
    setOpen((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <aside
      className={`h-screen sticky top-0 shrink-0 bg-gray-950 border-r border-gray-800 flex flex-col transition-[width] duration-200 ${collapsed ? 'w-16' : 'w-72'}`}
      data-testid="admin-sidebar"
    >
      <div className="flex items-center justify-between px-4 h-16 border-b border-gray-800">
        {!collapsed && <span className="text-white font-semibold tracking-tight">Yooin <span className="text-[#FF6B35]">Admin</span></span>}
        <button onClick={onToggle} className="text-gray-400 hover:text-white p-1" data-testid="sidebar-collapse-btn"
          aria-label={collapsed ? 'Expandir menú' : 'Contraer menú'}>
          {collapsed ? <ChevronsRight className="w-5 h-5" /> : <ChevronsLeft className="w-5 h-5" />}
        </button>
      </div>

      <nav className="flex-1 overflow-y-auto py-3">
        {visibleModules(can).map((m) => {
          const Icon = m.icon;
          const isActiveModule = m.items.some((i) => i.id === active);
          const badge = m.items.reduce((n, i) => n + (badges[i.id] || 0), 0);
          return (
            <div key={m.key} className="px-2">
              <button
                onClick={() => toggleModule(m.key)}
                title={m.label}
                className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${isActiveModule ? 'text-white bg-gray-900' : 'text-gray-400 hover:text-white hover:bg-gray-900/60'}`}
                data-testid={`sidebar-module-${m.key}`}
              >
                <Icon className={`w-5 h-5 shrink-0 ${isActiveModule ? 'text-[#FF6B35]' : ''}`} />
                {!collapsed && <span className="flex-1 text-left">{m.label}</span>}
                {!collapsed && badge > 0 && <span className="bg-red-500 text-white text-[10px] rounded-full px-1.5">{badge}</span>}
                {!collapsed && <ChevronDown className={`w-4 h-4 transition-transform ${open[m.key] ? 'rotate-180' : ''}`} />}
              </button>
              {!collapsed && open[m.key] && (
                <div className="ml-8 mt-1 mb-2 border-l border-gray-800">
                  {m.items.map((i) => (
                    <button
                      key={i.id}
                      onClick={() => onSelect(i.id)}
                      className={`w-full text-left pl-4 pr-2 py-2 text-sm transition-colors ${active === i.id ? 'text-[#FF6B35]' : 'text-gray-400 hover:text-white'}`}
                      data-testid={`sidebar-item-${i.id}`}
                    >
                      {i.label}
                      {i.pending && <span className="ml-2 text-[10px] text-gray-600">pendiente</span>}
                      {badges[i.id] > 0 && <span className="ml-2 bg-red-500 text-white text-[10px] rounded-full px-1.5">{badges[i.id]}</span>}
                    </button>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </nav>

      <div className="border-t border-gray-800 p-3">
        {!collapsed && <p className="text-gray-500 text-xs truncate" data-testid="sidebar-user-email">{user?.email}</p>}
        {!collapsed && <p className="text-[#FF6B35] text-xs mb-2" data-testid="sidebar-user-role">{user?.admin_role_label}</p>}
        <button onClick={onLogout} className="flex items-center gap-2 text-gray-400 hover:text-red-400 text-sm" data-testid="sidebar-logout-btn">
          <LogOut className="w-4 h-4" />{!collapsed && 'Cerrar sesión'}
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;
